<h2 *ngIf="mode === 'add'; else editDialoge" mat-dialog-title>
  {{ "Masters.clinics.Add" | translate }}
</h2>
<ng-template #editDialoge>
  <h2 mat-dialog-title>
    {{ "Masters.clinics.Edit" | translate }}
  </h2>
</ng-template>
<mat-divider></mat-divider>
<mat-dialog-content class="state-dialog add-clinic-dialog">
  <mat-stepper [linear]="isLinear" #stepper>
    <mat-step [stepControl]="clinicFormGroup">
      <form [formGroup]="clinicFormGroup">
        <ng-template matStepLabel>Hospital</ng-template>
        <mat-form-field class="clinic-form-field">
          <mat-label>{{
            "Masters.clinics.Placeholder.Add" | translate
          }}</mat-label>
          <input
            matInput
            placeholder="{{ 'Masters.clinics.Placeholder.Add' | translate }}"
            formControlName="clinicName"
          />
        </mat-form-field>
        <mat-form-field class="clinic-form-field">
          <mat-label>{{
            "Masters.clinics.Placeholder.AddDisplayName" | translate
          }}</mat-label>
          <input
            matInput
            placeholder="{{
              'Masters.clinics.Placeholder.AddDisplayName' | translate
            }}"
            formControlName="clinicDisplayName"
          />
        </mat-form-field>

        <mat-form-field class="clinic-form-field">
          <mat-label>{{
            "Masters.clinics.Placeholder.ShortCode" | translate
          }}</mat-label>
          <input
            matInput
            placeholder="{{
              'Masters.clinics.Placeholder.ShortCode' | translate
            }}"
            formControlName="shortCodeName"
          />
        </mat-form-field>

        <ng-container formGroupName="address">
          <mat-form-field class="clinic-form-field">
            <mat-label>{{ "Masters.clinics.State" | translate }}</mat-label>
            <mat-select
              placeholder="{{
                'Masters.clinics.Placeholder.Address.State' | translate
              }}"
              formControlName="state"
              (selectionChange)="onSelectionChange($event.value)"
            >
              <mat-option value="">--</mat-option>
              <mat-option *ngFor="let state of stateList" [value]="state.id">
                {{ state.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="clinic-form-field">
            <mat-label>{{ "City" | translate }}</mat-label>
            <mat-select
              placeholder="{{ 'City' | translate }}"
              formControlName="city"
            >
              <mat-option value="">--</mat-option>
              <mat-option *ngFor="let city of cityList" [value]="city.id">
                {{ city.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="clinic-form-field">
            <mat-label>{{
              "Masters.clinics.Placeholder.Address.Line1" | translate
            }}</mat-label>
            <input
              matInput
              placeholder="{{
                'Masters.clinics.Placeholder.Address.Line1' | translate
              }}"
              formControlName="line1"
            />
          </mat-form-field>
          <mat-form-field class="clinic-form-field">
            <mat-label>{{
              "Masters.clinics.Placeholder.Address.Line2" | translate
            }}</mat-label>
            <input
              matInput
              placeholder="{{
                'Masters.clinics.Placeholder.Address.Line2' | translate
              }}"
              formControlName="line2"
            />
          </mat-form-field>
          <mat-form-field class="clinic-form-field">
            <mat-label>{{ "zipCode" | translate }}</mat-label>
            <input
              matInput
              placeholder="{{ 'zipCode' | translate }}"
              formControlName="zipCode"
            />
          </mat-form-field>
        </ng-container>
        <mat-form-field class="clinic-form-field">
          <mat-label>{{ "MobileNumberPrimary" | translate }}</mat-label>
          <input
            matInput
            placeholder="{{ 'MobileNumberPrimary' | translate }}"
            formControlName="mobileNumberPrimary"
          />
        </mat-form-field>
        <mat-form-field class="clinic-form-field">
          <mat-label>{{ "MobileNumberSecondary" | translate }}</mat-label>
          <input
            matInput
            placeholder="{{ 'MobileNumberSecondary' | translate }}"
            formControlName="mobileNumberSecondary"
          />
        </mat-form-field>
        <mat-form-field class="clinic-form-field">
          <mat-label>{{ "EmailAddress" | translate }}</mat-label>
          <input
            matInput
            placeholder="{{ 'EmailAddress' | translate }}"
            formControlName="emailAddress"
          />
        </mat-form-field>
        <mat-form-field class="clinic-form-field">
          <mat-label>{{ "WhatsappNumber" | translate }}</mat-label>
          <input
            matInput
            placeholder="{{ 'WhatsappNumber' | translate }}"
            formControlName="whatsappNumber"
          />
        </mat-form-field>
        <mat-form-field class="clinic-form-field">
          <mat-label>{{ "ReviewLink" | translate }}</mat-label>
          <textarea
            class="textArea"
            matInput
            placeholder="{{ 'ReviewLink' | translate }}"
            formControlName="reviewLink"
          ></textarea>
        </mat-form-field>
        <mat-form-field class="clinic-form-field">
          <mat-label>{{ "GoogleMapLink" | translate }}</mat-label>
          <textarea
            class="textArea"
            matInput
            placeholder="{{ 'GoogleMapLink' | translate }}"
            formControlName="mapLink"
          ></textarea>
        </mat-form-field>

        <div
          class="checkbox"
          fxLayout="row"
          fxLayoutAlign="space-between center"
        >
          <mat-label>Show on patient app</mat-label>
          <mat-checkbox formControlName="showUser"> </mat-checkbox>
        </div>

        <div
          class="checkbox"
          fxLayout="row"
          fxLayoutAlign="space-between center"
        >
          <mat-label>Show on backoffice app</mat-label>
          <mat-checkbox formControlName="showReceptionist"> </mat-checkbox>
        </div>

        <mat-dialog-actions fxLayoutGap="20px" align="end">
          <button class="mat-raised-button mat-secondary" (click)="close()">
            {{ "Close" | translate }}
          </button>
          <button
            mat-button
            matStepperNext
            class="mat-raised-button mat-primary"
            [disabled]="!clinicFormGroup.valid"
          >
            Next
          </button>
        </mat-dialog-actions>
      </form>
    </mat-step>

    <mat-step [stepControl]="companyFormGroup">
      <form [formGroup]="companyFormGroup">
        <ng-template matStepLabel>Company</ng-template>
        <mat-form-field class="clinic-form-field">
          <mat-label>{{
            "Masters.clinics.Company.Placeholder.Add" | translate
          }}</mat-label>
          <input
            matInput
            placeholder="{{
              'Masters.clinics.Company.Placeholder.Add' | translate
            }}"
            formControlName="companyName"
          />
        </mat-form-field>
        <ng-container formGroupName="companyAddress">
          <mat-form-field class="clinic-form-field">
            <mat-label>{{ "Masters.clinics.State" | translate }}</mat-label>
            <mat-select
              placeholder="{{
                'Masters.clinics.Placeholder.Address.State' | translate
              }}"
              formControlName="state"
              (selectionChange)="onSelectionChangeOnCompany($event.value)"
            >
              <mat-option value="">--</mat-option>
              <mat-option
                *ngFor="let state of company.stateList"
                [value]="state.id"
              >
                {{ state.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="clinic-form-field">
            <mat-label>{{ "City" | translate }}</mat-label>
            <mat-select
              placeholder="{{ 'City' | translate }}"
              formControlName="city"
            >
              <mat-option value="">--</mat-option>
              <mat-option
                *ngFor="let city of company.cityList"
                [value]="city.id"
              >
                {{ city.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="clinic-form-field">
            <mat-label>{{
              "Masters.clinics.Company.Placeholder.Address.Line1" | translate
            }}</mat-label>
            <input
              matInput
              placeholder="{{
                'Masters.clinics.Placeholder.Address.Line1' | translate
              }}"
              formControlName="line1"
            />
          </mat-form-field>
          <mat-form-field class="clinic-form-field">
            <mat-label>{{
              "Masters.clinics.Company.Placeholder.Address.Line2" | translate
            }}</mat-label>
            <input
              matInput
              placeholder="{{
                'Masters.clinics.Company.Placeholder.Address.Line2' | translate
              }}"
              formControlName="line2"
            />
          </mat-form-field>
          <mat-form-field class="clinic-form-field">
            <mat-label>{{ "zipCode" | translate }}</mat-label>
            <input
              matInput
              placeholder="{{ 'zipCode' | translate }}"
              formControlName="zipCode"
            />
          </mat-form-field>
        </ng-container>
        <mat-form-field class="clinic-form-field">
          <mat-label>{{
            "Masters.clinics.Company.Placeholder.Gst" | translate
          }}</mat-label>
          <input
            matInput
            placeholder="{{
              'Masters.clinics.Company.Placeholder.Gst' | translate
            }}"
            formControlName="companyGst"
          />
        </mat-form-field>
        <mat-form-field class="clinic-form-field">
          <mat-label>{{
            "Masters.clinics.Company.Placeholder.Cin" | translate
          }}</mat-label>
          <input
            matInput
            placeholder="{{
              'Masters.clinics.Company.Placeholder.Cin' | translate
            }}"
            formControlName="companyCin"
          />
        </mat-form-field>

        <mat-dialog-actions fxLayoutGap="20px" align="end">
          <button class="mat-raised-button mat-secondary" matStepperPrevious>
            {{ "Back" | translate }}
          </button>
          <button
            mat-button
            matStepperNext
            class="mat-raised-button mat-primary"
            [disabled]="!companyFormGroup.valid"
          >
            Next
          </button>
        </mat-dialog-actions>
      </form>
    </mat-step>

    <mat-step
      [stepControl]="isClinicPharmacy ? pharmacyFormGroup : dummyFormGroup"
    >
      <ng-template matStepLabel>Pharmacy</ng-template>

      <div
        style="display: flex; align-items: baseline; gap: 44px"
        id="pharmacy-form-toggle"
      >
        <p>Do we have a pharmacy in hospital?</p>
        <div>
          <mat-slide-toggle
            [disabled]="isClinicPharmacyPresent"
            [(ngModel)]="isClinicPharmacy"
            color="primary"
          >
          </mat-slide-toggle>
        </div>
      </div>
      <form [formGroup]="pharmacyFormGroup" *ngIf="isClinicPharmacy">
        <mat-form-field class="clinic-form-field">
          <mat-label>{{ "Licence No 20" | translate }}</mat-label>
          <input
            matInput
            placeholder="{{ 'Licence No 20' | translate }}"
            formControlName="licence20"
          />
        </mat-form-field>

        <mat-form-field
          class="clinic-form-field"
          (click)="licence20Expiry.open()"
        >
          <mat-label>{{ "Expiry Date" | translate }}</mat-label>
          <input
            placeholder="{{ 'Expiry Date' | translate }}"
            matInput
            readonly
            [matDatepicker]="licence20Expiry"
            formControlName="licence20Expiry"
            [min]="today"
          />

          <mat-datepicker-toggle matSuffix [for]="licence20Expiry">
          </mat-datepicker-toggle>
          <mat-datepicker #licence20Expiry startView="year"></mat-datepicker>
        </mat-form-field>

        <div class="file-upload-box-wrapper">
          <div
            class="file-upload-box"
            [ngClass]="{ 'invalid-file': !pharmacyFileValidations.licence20 }"
            (click)="licenseNo20Thumbnail || licenseNo20Input.click()"
          >
            <img
              *ngIf="licenseNo20Thumbnail && !licenseNo20Thumbnail.isPdf"
              [matTooltip]="licenseNo20Thumbnail?.name || ''"
              [src]="licenseNo20Thumbnail.dataURI || licenseNo20Thumbnail.url"
              class="uploaded-thumbnail"
              (click)="
                openImagePreview(
                  licenseNo20Thumbnail.dataURI || licenseNo20Thumbnail.url
                )
              "
            />
            <mat-icon
              *ngIf="licenseNo20Thumbnail && licenseNo20Thumbnail.isPdf"
              (click)="
                openPdf(
                  licenseNo20Thumbnail.localPdfUrl || licenseNo20Thumbnail.url
                )
              "
              [matTooltip]="licenseNo20Thumbnail?.name || ''"
              class="pdf_icon"
              >picture_as_pdf</mat-icon
            >
            <mat-icon *ngIf="!licenseNo20Thumbnail">cloud_upload</mat-icon>
            <p *ngIf="!licenseNo20Thumbnail">Upload Licence 20</p>
            <input
              type="file"
              #licenseNo20Input
              hidden
              (change)="onFileSelected($event, 'licenseNo20')"
              accept=".png, .jpg, .jpeg, .pdf"
            />
          </div>
          <mat-icon
            *ngIf="licenseNo20Thumbnail"
            class="delete"
            (click)="removeLicenseNo20mage()"
            svgIcon="trash"
          ></mat-icon>
        </div>

        <mat-form-field class="clinic-form-field">
          <mat-label>{{ "Licence No 21" | translate }}</mat-label>
          <input
            matInput
            placeholder="{{ 'Licence No 21' | translate }}"
            formControlName="licence21"
          />
        </mat-form-field>

        <mat-form-field
          class="clinic-form-field"
          (click)="licence21Expiry.open()"
        >
          <mat-label>{{ "Expiry Date" | translate }}</mat-label>
          <input
            placeholder="{{ 'Expiry Date' | translate }}"
            matInput
            readonly
            [matDatepicker]="licence21Expiry"
            formControlName="licence21Expiry"
            [min]="today"
          />

          <mat-datepicker-toggle matSuffix [for]="licence21Expiry">
          </mat-datepicker-toggle>
          <mat-datepicker #licence21Expiry startView="year"></mat-datepicker>
        </mat-form-field>

        <div id="file-upload-wrapper">
          <div class="file-upload-box-wrapper">
            <div
              class="file-upload-box"
              [ngClass]="{ 'invalid-file': !pharmacyFileValidations.licence21 }"
              (click)="licenseNo21Thumbnail || licenseNo21Input.click()"
            >
              <img
                *ngIf="licenseNo21Thumbnail && !licenseNo21Thumbnail.isPdf"
                [matTooltip]="licenseNo21Thumbnail?.name || ''"
                [src]="licenseNo21Thumbnail.dataURI || licenseNo21Thumbnail.url"
                class="uploaded-thumbnail"
                (click)="
                  openImagePreview(
                    licenseNo21Thumbnail.dataURI || licenseNo21Thumbnail.url
                  )
                "
              />
              <mat-icon
                *ngIf="licenseNo21Thumbnail && licenseNo21Thumbnail.isPdf"
                (click)="
                  openPdf(
                    licenseNo21Thumbnail.localPdfUrl || licenseNo21Thumbnail.url
                  )
                "
                [matTooltip]="licenseNo21Thumbnail?.name || ''"
                class="pdf_icon"
                >picture_as_pdf</mat-icon
              >

              <mat-icon *ngIf="!licenseNo21Thumbnail">cloud_upload</mat-icon>
              <p *ngIf="!licenseNo21Thumbnail">Upload Licence 21</p>
              <input
                type="file"
                #licenseNo21Input
                hidden
                (change)="onFileSelected($event, 'licenseNo21')"
                accept=".png, .jpg, .jpeg, .pdf"
              />
            </div>
            <mat-icon
              *ngIf="licenseNo21Thumbnail"
              class="delete"
              (click)="removeLicenseNo21mage()"
              svgIcon="trash"
            ></mat-icon>
          </div>
        </div>

        <mat-form-field class="clinic-form-field">
          <mat-label>{{ "Fssai No" | translate }}</mat-label>
          <input
            matInput
            placeholder="{{ 'Fssai No' | translate }}"
            formControlName="fssai"
          />
        </mat-form-field>

        <mat-form-field
          class="clinic-form-field"
          (click)="fssaiNoExpiry.open()"
        >
          <mat-label>{{ "Expiry Date" | translate }}</mat-label>
          <input
            placeholder="{{ 'Expiry Date' | translate }}"
            matInput
            readonly
            [matDatepicker]="fssaiNoExpiry"
            formControlName="fssaiNoExpiry"
            [min]="today"
          />

          <mat-datepicker-toggle matSuffix [for]="fssaiNoExpiry">
          </mat-datepicker-toggle>
          <mat-datepicker #fssaiNoExpiry startView="year"></mat-datepicker>
        </mat-form-field>

        <div class="file-upload-box-wrapper">
          <div
            class="file-upload-box"
            (click)="fssiNoThumbnail || fssiNoInput.click()"
          >
            <img
              *ngIf="fssiNoThumbnail && !fssiNoThumbnail.isPdf"
              [matTooltip]="fssiNoThumbnail?.name || ''"
              [src]="fssiNoThumbnail.dataURI || fssiNoThumbnail.url"
              class="uploaded-thumbnail"
              (click)="
                openImagePreview(fssiNoThumbnail.dataURI || fssiNoThumbnail.url)
              "
            />
            <mat-icon
              *ngIf="fssiNoThumbnail && fssiNoThumbnail.isPdf"
              (click)="
                openPdf(fssiNoThumbnail.localPdfUrl || fssiNoThumbnail.url)
              "
              [matTooltip]="fssiNoThumbnail?.name || ''"
              class="pdf_icon"
              >picture_as_pdf</mat-icon
            >

            <mat-icon *ngIf="!fssiNoThumbnail">cloud_upload</mat-icon>
            <p *ngIf="!fssiNoThumbnail">Upload FSSAI</p>
            <input
              type="file"
              #fssiNoInput
              hidden
              (change)="onFileSelected($event, 'fssiNo')"
              accept=".png, .jpg, .jpeg, .pdf"
            />
          </div>
          <mat-icon
            *ngIf="fssiNoThumbnail"
            class="delete"
            (click)="removeFssiImage()"
            svgIcon="trash"
          ></mat-icon>
        </div>

        <div class="file-upload-box-wrapper digital-signature">
          <p class="digital-signature">Digital Signature</p>
          <div
            class="file-upload-box"
            [ngClass]="{
              'invalid-file': !pharmacyFileValidations.digitalSignature
            }"
            (click)="digitalSignatureThumbnail || digitalSignatureInput.click()"
          >
            <img
              *ngIf="
                digitalSignatureThumbnail && !digitalSignatureThumbnail.isPdf
              "
              [matTooltip]="digitalSignatureThumbnail?.name || ''"
              [src]="
                digitalSignatureThumbnail.dataURI ||
                digitalSignatureThumbnail.url
              "
              class="uploaded-thumbnail"
              (click)="
                openImagePreview(
                  digitalSignatureThumbnail.dataURI ||
                    digitalSignatureThumbnail.url
                )
              "
            />
            <mat-icon
              *ngIf="
                digitalSignatureThumbnail && digitalSignatureThumbnail.isPdf
              "
              (click)="
                openPdf(
                  digitalSignatureThumbnail.localPdfUrl ||
                    digitalSignatureThumbnail.url
                )
              "
              [matTooltip]="digitalSignatureThumbnail?.name || ''"
              class="pdf_icon"
              >picture_as_pdf</mat-icon
            >
            <mat-icon *ngIf="!digitalSignatureThumbnail">cloud_upload</mat-icon>
            <p *ngIf="!digitalSignatureThumbnail">Upload Digital Signature</p>
            <input
              type="file"
              #digitalSignatureInput
              hidden
              (change)="onFileSelected($event, 'digitalSignature')"
              accept=".png, .jpg, .jpeg"
            />
          </div>
          <mat-icon
            *ngIf="digitalSignatureThumbnail"
            class="delete"
            (click)="removeDigitalSignatureThumbnail()"
            svgIcon="trash"
          ></mat-icon>
        </div>

        <mat-form-field class="clinic-form-field">
          <mat-label>Contact Number</mat-label>
          <input
            matInput
            maxlength="10"
            placeholder="Contact Number"
            formControlName="pharmacyMobileNumber"
          />
        </mat-form-field>

        <mat-form-field class="clinic-form-field">
          <mat-label>PAN Number</mat-label>
          <input
            matInput
            placeholder="PAN Number"
            formControlName="panNumber"
          />
        </mat-form-field>
      </form>

      <mat-dialog-actions fxLayoutGap="20px" align="end">
        <button class="mat-raised-button mat-secondary" matStepperPrevious>
          {{ "Back" | translate }}
        </button>
        <button
          mat-button
          matStepperNext
          class="mat-raised-button mat-primary"
          [disabled]="isClinicPharmacy && pharmacyFormGroup.invalid"
        >
          Next
        </button>
      </mat-dialog-actions>
    </mat-step>

    <mat-step [stepControl]="posFormGroup">
      <ng-template matStepLabel>POS</ng-template>

      <div id="pos-add-button">
        <mat-icon
          style="margin-top: 6px"
          class="reason-tooltip material-icons-outlined"
          [matTooltip]="
            '1 POS device can be attached to multiple billing locations and a single billing location cannot have more than one POS device attached'
          "
          matTooltipPosition="above"
          >info</mat-icon
        >

        <button
          style="font-size: 12px"
          mat-button
          class="mat-raised-button mat-primary"
          (click)="addPOS()"
        >
          {{ "Add New POS" | translate }}
        </button>
      </div>

      <form
        style="margin-top: 14px"
        *ngIf="posFormGroup"
        [formGroup]="posFormGroup"
      >
        <div formArrayName="posList">
          <div
            style="
              background: #f5f5f5;
              padding: 10px;
              border-radius: 8px;
              margin-bottom: 16px;
            "
            *ngFor="let pos of posList.controls; let i = index"
            [formGroupName]="i"
          >
            <mat-form-field class="clinic-form-field">
              <mat-label>{{ "POS Name" | translate }}</mat-label>
              <input
                matInput
                placeholder="{{ 'POS Name' | translate }}"
                formControlName="posName"
              />
            </mat-form-field>

            <mat-form-field class="clinic-form-field">
              <mat-label>{{ "Terminal Id" | translate }}</mat-label>
              <input
                matInput
                placeholder="{{ 'Terminal Id' | translate }}"
                formControlName="terminalId"
              />
            </mat-form-field>

            <mat-form-field class="clinic-form-field">
              <mat-label>{{ "Merchant Id" | translate }}</mat-label>
              <input
                matInput
                placeholder="{{ 'Merchant Id' | translate }}"
                formControlName="merchantId"
              />
            </mat-form-field>

            <mat-form-field class="clinic-form-field">
              <mat-label>{{ "Location" | translate }}</mat-label>
              <mat-select formControlName="location" multiple>
                <mat-option [value]="1">Front Desk</mat-option>
                <mat-option [value]="2">Lab</mat-option>
                <mat-option [value]="3">Pharmacy</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="clinic-form-field">
              <mat-label>{{ "POS Vendor" | translate }}</mat-label>
              <input
                matInput
                placeholder="{{ 'Pos Vendor' | translate }}"
                formControlName="posVendor"
              />
            </mat-form-field>

            <div id="pos-add-button">
              <button
                mat-button
                id="remove-coupon"
                class="mat-flat-button mat-warn"
                (click)="removePOS(i)"
              >
                {{ "Remove" | translate }}
              </button>

              <button
                *ngIf="!pos.get('added')?.value"
                mat-button
                style="font-size: 12px"
                class="mat-raised-button mat-primary"
                (click)="submitPOS(i)"
              >
                {{ "Add" | translate }}
              </button>
            </div>
          </div>
        </div>
      </form>

      <mat-dialog-actions fxLayoutGap="20px" align="end">
        <button
          mat-button
          matStepperPrevious
          class="mat-raised-button mat-secondary"
        >
          {{ "Back" | translate }}
        </button>
        <button
          mat-button
          *ngIf="mode === 'add'; else UpdateButton"
          class="mat-raised-button mat-primary"
          [disabled]="isClinicPharmacy && pharmacyFormGroup.invalid"
          (click)="add()"
        >
          {{ "Add" | translate }}
        </button>
        <ng-template #UpdateButton>
          <button
            mat-button
            class="mat-raised-button mat-primary"
            [disabled]="isClinicPharmacy && pharmacyFormGroup.invalid"
            (click)="add()"
          >
            {{ "Update" | translate }}
          </button>
        </ng-template>
      </mat-dialog-actions>
    </mat-step>
  </mat-stepper>
</mat-dialog-content>
